import { IDisplayedMeasure, YAxisPosition } from '../interfaces';

// Check if the measure format already setup on the current YAxisPosition
// if so, we need to tell the user that YAxis format will override the measure format.
export const checkIfMeasureFormatAppliedOnYAxis = ({
  displayedMeasures,
  yAxisPosition,
}: {
  displayedMeasures: IDisplayedMeasure[];
  yAxisPosition: YAxisPosition;
}): boolean => {
  const measuresOnAxis = displayedMeasures.filter(
    (setting) => setting.yAxisPosition === yAxisPosition,
  );

  const isAppliedMeasureFormat = measuresOnAxis.some(
    (setting) => setting.format,
  );
  return isAppliedMeasureFormat;
};
